import { atom } from "jotai";

import { selectedRoundAtom } from "../../stores";

export const setRateIdOnRoundAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      rateId: string;
    }
  ) => {
    const selectedRound = get(selectedRoundAtom);
    if (!selectedRound || !selectedRound.rate) {
      return;
    }

    set(selectedRoundAtom, {
      ...selectedRound,
      rate: {
        ...selectedRound.rate,
        id: payload.rateId,
      },
    });
  }
);
